<template>
  <div class="col-xs-12 p-0">
    <table class="table table-responsive emergo-table"  :class="{ 'mb-0': !filteredData.length }">
      <thead>
        <tr style="background-color: #E6E6E6; !important;">
          <th class="" style="width:60px" v-if="roleId !== roleInfo['RA Admin']">
            <div class="checkbox-wrapper">
              <label class="custom-checkbox">
                <input v-model="checkAllRegistrations" @click="selectAll()" type="checkbox" />
                <span class="select-check"></span>
              </label>
            </div>
          </th>

          <template v-for="(header, key) in tableHeaders">
            <template v-if="header === 'Archive reason' && columns.includes(header) && filterKey === 'Archive'">
              <th @click="sortBy(header)" :key="header">
                <div class="tableHeader">
                  <div class="header-ellipsis" :title="$t(key)">{{ $t(key) }}</div>
                  <span class="sort-key p-relative" :class="sortOrders[header] > 0 ? 'asc' : 'dsc'"> </span>
                </div>
              </th>
            </template>
            <th
              @click="sortBy(header)"
              v-else-if="columns.includes(header) && header !== 'Archive reason'"
              :key="header"
            >
              <div class="tableHeader">
                <div class="header-ellipsis" :title="$t(key)">{{ $t(key) }}</div>
                <span class="sort-key p-relative" :class="sortOrders[header] > 0 ? 'asc' : 'dsc'"> </span>
              </div>
            </th>
          </template>
          <th
            style="width:55px"
            v-if="
              permissions.indexOf('ADD_A_RECORD') > -1 ||
                permissions.indexOf('EMAIL_REGISTRATION_SHARE') > -1 ||
                (permissions.indexOf('ARCHIEVE_A_REGISTRATION') > -1 && !archivedFlag) ||
                permissions.indexOf('DELETE_A_REGISTRATION') > -1 ||
                (permissions.indexOf('UNARCHIEVE_A_REGISTRATION') > -1 && archivedFlag) ||
                permissions.indexOf('VIEW_HISTORY') > -1
            "
          ></th>
        </tr>
      </thead>
      <tbody ref="tbodyBox">
        <tr
          :class="{'cursor-text':filterKey.toLowerCase() == 'invalid records'}"
          v-for="entry in filteredData"
          :key="entry.registrationId"
          :id="entry.registrationId"
          @click="viewRegistration(entry, $event)"
        >
          <td style="width: 40px;" v-if="columns.length > 0 && roleId !== roleInfo['RA Admin']">
            <div class="checkbox-wrapper">
              <label class="custom-checkbox" @click="disableModal(entry.registrationId, $event)">
                <input type="checkbox" @click="deselect" :value="entry" v-model="selectedRegistration" />
                <span class="select-check"></span>
              </label>
            </div>
          </td>
          <td v-if="columns.indexOf('Product name') > -1" class="header-ellipsis">
            <!-- {{ entry['Product'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Product'], registrationSearch)"
              :title="entry['Product']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Barcode') > -1" class="header-ellipsis">
            <span
              v-html="$options.filters.highlight(entry['Barcode'], registrationSearch)"
              :title="entry['Barcode']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Certification number') > -1" class="header-ellipsis">
            <!-- {{ entry['submissionNumber'] }} -->
            <span
              v-html="$options.filters.highlight(entry['submissionNumber'], registrationSearch)"
              :title="entry['submissionNumber']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Country of origin') > -1" class="header-ellipsis">
            {{ translateCountry(entry['Country']) }}
          </td>
          <td v-if="columns.indexOf('Managed by') > -1" class="header-ellipsis">
            <span v-html="$options.filters.highlight(entry['Local representative'], registrationSearch)"></span>
          </td>
          <td v-if="columns.indexOf('Expiration') > -1" class="header-ellipsis">
            <span
              class="remaining"
              v-if="expiryDateFormate == 'remaining'"
              v-html="$options.filters.highlight(entry['Expiration'], registrationSearch)"
            ></span>
            <span
              class="actual"
              v-if="expiryDateFormate == 'Actual date' || expiryDateFormate == null || expiryDateFormate == ''"
              v-html="$options.filters.highlight(translate(entry['Expiration Date']), registrationSearch)"
            ></span>
          </td>
          <td v-if="columns.indexOf('Approval date') > -1" class="header-ellipsis">
            <!-- {{ entry['Approval date'] }} -->
            <span v-html="$options.filters.highlight(translate(entry['Approval date']), registrationSearch)"></span>
          </td>
          <td v-if="columns.indexOf('Maintenance date') > -1" class="header-ellipsis">
            <span v-html="$options.filters.highlight(translate(entry['Maintenance date']), registrationSearch)"></span>
          </td>
            <td v-if="columns.indexOf('Next maintenance date') > -1" class="header-ellipsis">
            <span v-html="$options.filters.highlight(translate(entry['Next maintenance date']), registrationSearch)"></span>
          </td>
          <td v-if="columns.indexOf('Archive reason') > -1 && filterKey === 'Archive'" class="header-ellipsis">
            <!-- {{ entry['archiveReasonName'] }} -->
            <span
              v-html="$options.filters.highlight(entry['archiveReasonName'], registrationSearch)"
              :title="entry['archiveReasonName']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Attachments') > -1" class="header-ellipsis">
            <span v-if="entry['attachmentLinks'] != ''" :title="entry['attachmentLinks'] | fileName">
              <span v-for="file in entry['attachmentLinks']" :key="file">{{
                file.split('/')[file.split('/').length - 1]
              }}</span>
            </span>
          </td>
          <td v-if="columns.indexOf('Comments') > -1" style="position: relative;" class="ellipsis">
            <el-tooltip effect="light" placement="bottom-start" :content="entry.Comments + '.'">
              <span v-if="entry['Comments'] != null">
                <el-link>
                  <span style="cursor: pointer;">{{ entry.Comments.substring(0, 8) }}</span>
                </el-link>
              </span>
            </el-tooltip>
          </td>
          <td v-if="columns.indexOf('Description') > -1" class="ellipsis">
            <!-- {{ entry['Configuration'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Configuration'], registrationSearch)"
              :title="entry['Configuration']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Model name') > -1" class="ellipsis">
            <!-- {{ entry['Device UDI'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Device UDI'], registrationSearch)"
              :title="entry['Device UDI']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Product class') > -1" class="ellipsis">
            <!-- {{ entry['Device class'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Device class'], registrationSearch)"
              :title="entry['Device class']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Product type') > -1" class="ellipsis">
            <!-- {{ entry['Device type'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Device type'], registrationSearch)"
              :title="entry['Device type']"
            ></span>
          </td>
          <td v-show="false" v-if="columns.indexOf('In Progress') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['In Progress'], registrationSearch)"
              :title="entry['In Progress']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Accredited by') > -1" class="ellipsis">
            <!-- {{ entry['Issued by'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Issued by'], registrationSearch)"
              :title="entry['Issued by']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Brand name') > -1 && roleId !== 6" class="ellipsis">
            <!-- {{ entry['Local distributor'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Local distributor'], registrationSearch)"
              :title="entry['Local distributor']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Manufacturer') > -1" class="ellipsis">
            <!-- {{ entry['Manufacturer'] }} -->
            <span
              v-html="$options.filters.highlight(entry['Manufacturer'], registrationSearch)"
              :title="entry['Manufacturer']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Certification URL') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['Record number'], registrationSearch)"
              :title="entry['Record number']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Status') > -1" style="position: relative;" class="ellipsis">
            <span v-if="entry.Status.toLowerCase() !== 'active' && filterKey.toLowerCase() !== 'invalid records' && filterKey.toLowerCase() !== 'draft'" class="d-flex">
              <el-tooltip effect="dark" placement="bottom-start">
                <div slot="content" v-html="titleMessage(entry.Status, entry)"></div>
                <el-link>
                  <span class="d-flex">
                    <img class="image-size"
                      v-if="entry.Status.toLowerCase() === 'expired'"
                      src="/static/images/icons/alert_triangle.svg"
                      alt
                    />
                    <img  class="image-size"
                      v-if="entry.Status.toLowerCase() === 'expiring soon' || entry.Status.toLowerCase() === 'action needed'"
                      src="/static/images/icons/expiring_soon.svg"
                      alt
                    />
                    <img  class="image-size"
                      v-if="entry.Status.toLowerCase() === 'pending'"
                      src="/static/images/icons/pending_icon.svg"
                      alt
                    />
                    <img  class="image-size"
                      v-if="entry.Status.toLowerCase() === 'active'"
                      src="/static/images/icons/active_green_icon.svg"
                      alt
                    />
                  </span>
                </el-link>
              </el-tooltip>
              <span style="cursor: pointer;" class="pl-10">{{ translateStatus(entry.Status) }}</span>
              <span v-if="entry.renewal_in_progress || entry.modification_in_progress">*</span>
            </span>
            <span class="d-flex" v-else>
              <span v-if="filterKey.toLowerCase() !== 'draft'">
                <img class="image-size" v-if="entry.Status.toLowerCase() === 'expired' && filterKey.toLowerCase() !== 'invalid records'" src="/static/images/icons/alert_triangle.svg" alt />
                <img class="image-size"
                  v-if="entry.Status.toLowerCase() === 'expiring soon' && filterKey.toLowerCase() !== 'invalid records'"
                  src="/static/images/icons/expiring_soon.svg"
                  alt
                />
                <img class="image-size" v-if="entry.Status.toLowerCase() === 'pending' && filterKey.toLowerCase() !== 'invalid records'" src="/static/images/icons/pending_icon.svg" alt />
                <img class="image-size"
                  v-if="entry.Status.toLowerCase() === 'active' && filterKey.toLowerCase() !== 'invalid records'"
                  src="/static/images/icons/active_green_icon.svg"
                  alt
                />
                <img class="image-size"
                  v-if="filterKey.toLowerCase() === 'invalid records'"
                  src="/static/images/icons/invalid_icon.svg"
                  alt
                />
              </span>
              <img class="image-size mt-2"
                v-if="filterKey.toLowerCase() === 'draft'"
                src="/static/images/icons/draft.svg"
                alt
              />
              <span style="cursor: pointer;" class="pl-10" v-if="filterKey.toLowerCase() !== 'invalid records' && filterKey.toLowerCase() !== 'draft'">{{ translateStatus(entry.Status) }}</span>
              <span style="cursor: pointer;" class="pl-10" v-if="filterKey.toLowerCase() === 'invalid records'" :title="entry.error">{{ entry.error }}</span>
              <span style="cursor: pointer;" class="pl-10" v-if="filterKey.toLowerCase() === 'draft'">{{ translateStatus('Draft') }}</span>

              <span v-if="filterKey.toLowerCase() !== 'draft' && (entry.renewal_in_progress || entry.modification_in_progress)">*</span>
            </span>
          </td>
          <td v-if="columns.indexOf('Product category') > -1" class="ellipsis">
            <span
              :title="entry['registrationType']"
              v-html="$options.filters.highlight(entry['registrationType'], registrationSearch)"
            ></span>
          </td>
          <td v-if="columns.indexOf('Standards') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['standards'], registrationSearch)"
              :title="entry['standards']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Ordinance') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['ordinance'], registrationSearch)"
              :title="entry['ordinance']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Imported Product') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['imported_product'] === true ? 'Yes' : (entry['imported_product'] === false ? 'No' : ''), registrationSearch)"
              :title="translateName(entry['imported_product'])"
            ></span>
          </td>
          <td v-if="columns.indexOf('Importer') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['importer'], registrationSearch)"
              :title="entry['importer']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Requester') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['requester'], registrationSearch)"
              :title="entry['requester']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Trade Representative') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['trade_representative'], registrationSearch)"
              :title="entry['trade_representative']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Input Status') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['inputStatus'], registrationSearch)"
              :title="entry['inputStatus']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Test Report') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['test_report'], registrationSearch)"
              :title="entry['test_report']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Test Report Attachments') > -1" class="ellipsis">
            <span
              v-if="entry['test_report_attachments'] != null"
              :title="getFileNames(entry['test_report_attachments'])"
            >
              <span>{{ getFileNames(entry['test_report_attachments']) }}</span>
            </span>
          </td>
          <td v-if="columns.indexOf('Product Certificate') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['product_certificate'], registrationSearch)"
              :title="entry['product_certificate']"
            ></span>
          </td>
          <td v-if="columns.indexOf('Product Certificate Attachments') > -1" class="ellipsis">
            <span
              v-if="entry['product_certificate_attachments'] != null"
              :title="getFileNames(entry['product_certificate_attachments'])"
            >
              {{ getFileNames(entry['product_certificate_attachments']) }}
            </span>
          </td>
          <!-- <td v-if="columns.indexOf('Barcode') > -1" class="ellipsis">
            <span
              v-html="$options.filters.highlight(entry['barcode'], registrationSearch)"
              :title="entry['barcode']"
            ></span>
          </td> -->
          <td v-if="columns.indexOf('Barcode Attachments') > -1" class="ellipsis">
            <span v-if="entry['barcode_attachments'] != null" :title="getFileNames(entry['barcode_attachments'])">
              <span>{{ getFileNames(entry['barcode_attachments']) }}</span>
            </span>
          </td>
          <td
            style="width: 55px;"
            data-toggle="dropdown"
            v-if="
              permissions.indexOf('ADD_A_RECORD') > -1 ||
                permissions.indexOf('EMAIL_REGISTRATION_SHARE') > -1 ||
                (permissions.indexOf('ARCHIEVE_A_REGISTRATION') > -1 && !archivedFlag) ||
                permissions.indexOf('DELETE_A_REGISTRATION') > -1 ||
                (permissions.indexOf('UNARCHIEVE_A_REGISTRATION') > -1 && archivedFlag) ||
                permissions.indexOf('VIEW_HISTORY') > -1
            "
          >
            <div
              :id="'trackerActionDots' + entry.registrationId"
              class="dropdown dropdown-export custom-three-dots three-dots"
              v-if="(roleId !== 3 || (filterKey.toLowerCase() !== 'draft' && filterKey.toLowerCase() !== 'invalid records'))"
            >
              <div class="w-100" data-toggle="dropdown" @click="menuDropdown" style="margin-top:1px;">
                <span class="dropdown-toggle" data-toggle="tooltip" data-placement="right">
                  <img class="info-img cursor-pointer" src="/static/images/icons/emergo_three_dots_menu.svg" />
                </span>
              </div>
              <ul
                class="dropdown-menu tooltip-pointer dropdown-menu-ul"
                v-bind:class="changeClass ? 'addReverse' : ''"
                @click="stopPropagateMethod"
              >
                <li
                  @click="editRecord(entry.registrationId, entry.isNewToMarket ? entry.isNewToMarket : false, filterKey.toLowerCase() === 'invalid records', entry)"
                  v-if="permissions.indexOf('ADD_A_RECORD') > -1 && !archivedFlag"
                  class="emergo-primary-text"
                  :class="archivedFlag ? 'removeTooltipSpace' : ''"
                >
                  {{ $t('edit') }}
                  <!-- <a style="color: #01518a;" @click="editRecord(entry.registrationId, entry.isNewToMarket)">
                    <img src="/static/images/icons/data_grid_edit_icon.svg" class="tracker-images mr-20" />
                    <span class="MRL-4">{{ $t('edit') }}</span>
                  </a> -->
                </li>
                  <li
                  @click="reviewCertificate(entry.registrationId, entry.isNewToMarket ? entry.isNewToMarket : false, true,entry)"
                  v-if="((roleId === 1|| roleId === roleInfo['Super Admin']))&&(filterKey.toLowerCase() === 'view all' || filterKey.toLowerCase() === 'Action Needed') && !entry.isNewToMarket && (entry.registrationType==='Small Household Appliances' || entry.registrationType==='ELETRODOMÉSTICOS')  && !entry.is_able_to_renew"
                  class="emergo-primary-text"
                >
                  {{ $t('reviewCertificate') }}
                </li>
                 <li
                  @click="renewCertificate(entry.registrationId)"
                  v-if="((roleId === 1|| roleId === roleInfo['Super Admin']) && entry.is_able_to_renew)"
                  class="emergo-primary-text"
                >
                  {{ $t('renewCertificate') }}
                </li>
                <li
                  @click="shareEmailLinkOnSelect(entry, $event)"
                  v-if="permissions.indexOf('EMAIL_REGISTRATION_SHARE') > -1 && (filterKey.toLowerCase() !== 'draft' && filterKey.toLowerCase() !== 'invalid records')"
                  class="emergo-primary-text"
                >
                  {{ $t('shareLink') }}
                  <!-- <a style="color: #01518a;" @click="shareEmailLinkOnSelect(entry, $event)">
                    <img src="/static/images/icons/inmetro_link_icon.svg" class="tracker-images mr-20" />
                    <span class="MRL-4">{{ $t('shareLink') }}</span>
                  </a> -->
                </li>
                <li
                  @click="viewHistory(entry.registrationId, $event)"
                  v-if="permissions.indexOf('VIEW_HISTORY') > -1 && (filterKey.toLowerCase() !== 'draft' && filterKey.toLowerCase() !== 'invalid records')"
                  class="emergo-primary-text"
                >
                  {{ $t('viewHistory') }}
                  <!-- <a style="color: #01518a;" @click="viewHistory(entry.registrationId, $event)">
                    <img src="/static/images/icons/data_grid_view_history_icon.svg" class="tracker-images mr-20" />
                    <span class="MRL-4">{{ $t('viewHistory') }}</span>
                  </a> -->
                </li>
                <li
                  @click="archiveRegistrationOnSelect(entry, $event)"
                  v-if="permissions.indexOf('ARCHIEVE_A_REGISTRATION') > -1 && !archivedFlag && (filterKey.toLowerCase() !== 'draft' && filterKey.toLowerCase() !== 'invalid records')"
                  class="emergo-primary-text"
                >
                  {{ $t('archive') }}
                  <!-- <a style="color: #01518a;" @click="archiveRegistrationOnSelect(entry, $event)">
                    <img src="/static/images/icons/inmetro_archive_icon.svg" class="tracker-images mr-20" />
                    <span class="MRL-4">{{ $t('archive') }}</span>
                  </a> -->
                </li>
                <li
                  @click="archiveRegistrationOnSelect(entry, $event)"
                  v-if="permissions.indexOf('UNARCHIEVE_A_REGISTRATION') > -1 && archivedFlag && (filterKey.toLowerCase() !== 'draft' && filterKey.toLowerCase() !== 'invalid records')"
                  class="emergo-primary-text"
                >
                  {{ $t('unarchive') }}
                  <!-- <a style="color: #01518a;" @click="archiveRegistrationOnSelect(entry, $event)">
                    <img
                      src="/static/images/icons/blue-un-archive-icon.svg"
                      style="margin-bottom: 1px;"
                      class="unarchive tracker-images mr-20"
                    />
                    <span class="MRL-4">{{ $t('unarchive') }}</span>
                  </a> -->
                </li>
                <li
                  @click="deleteRegistrationOnSelect(entry, $event)"
                  v-if="permissions.indexOf('DELETE_A_REGISTRATION') > -1"
                  class="emergo-delete-text"
                >
                  {{ $t('delete') }}
                  <!-- <a style="color:#B00505" @click="deleteRegistrationOnSelect(entry, $event)">
                    <img src="/static/images/icons/inmetro_trash_icon.svg" class="tracker-images mr-20" />
                    <span class="MRL-4">{{ $t('delete') }}</span>
                  </a> -->
                </li>
                <!-- <li @click="downloadRecord(entry)" class="emergo-primary-text" v-if="roleId === roleInfo['RA Admin']">
                  {{ $t('download') }} -->
                  <!-- <a style="color:#01518a;" @click="downloadRecord(entry)">
                    <img src="/static/images/icons/manage_compliance_download_icon.svg" class="tracker-images mr-20" />
                    <span class="MRL-4">{{ $t('download') }}</span>
                  </a> -->
                <!-- </li> -->
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="filteredData.length == 0 && !loadingStatus" class="col-xs-12 no-records-found p-20">
      {{ $t('noCertificatesFound') }}
    </div>

    <!-- <registration-details-popup
      :permissions="permissions"
      :dataRow="activeRegistration"
      :countryCertificateType="countryCertificateType"
      @setSearch="setSearch"
      @hidePopup="hidePopup"
      :archivedFlag="archivedFlag"
      :totalRecordsData="totalRecordsData"
    ></registration-details-popup> -->
    <file-upload-regi
      :regiId="selectedAttachmentRegistration.registrationId"
      :dataAttachment="selectedAttachmentRegistration.attachmentLinks"
    ></file-upload-regi>
    <confirmation-popup :title="$t('renewCertificate')" :confirmationText="$t('renewCertificateMessage')" @proceedChanges="proceedChanges"></confirmation-popup>
    <loader :loadingStatus="tableLoader"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
// import { camelCase } from 'lodash';
import moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import { TABLE_HEADERS } from './complianceDashboard/constants';
// import RegistrationDetailsPopup from './RegistrationDetailsPopup.vue';
import { getRegistrationDetailsById, updateStatus } from '../../apis/registrations';
import validateRegDetailsData from '../../utils/registrationDetails';
import FileUploadRegi from '../UIComponents/FileUploadRegi.vue';
import EventBus from '../../utils/event-bus';
import ConfirmationPopup from '../Common/ULConfirmationPopup.vue';
import { isRegulationChecked } from '../../apis/regulationCheck';
import { getToDoListDetails } from '../../apis/ToDoList';

export default {
  components: {
    // RegistrationDetailsPopup,
    FileUploadRegi,
    Loader,
    ConfirmationPopup
  },
  props: {
    tableLoader: Boolean,
    threeDotsPermissionFlag: Boolean,
    permissions: Array,
    enableCheckAll: Boolean,
    effectedByRegulatoryAlert: Array,
    countryCertificateType: Array,
    data: Array,
    columns: Array,
    filterKey: String,
    selectedRegistrationList: Array,
    loadingStatus: Boolean,
    disableContent: Boolean,
    refreshDataAfterDeleteRecord: Boolean,
    archivedFlag: Boolean,
    openRegistrationId: String,
    roleId: Number,
    activeId: Set,
    exportStatus: Boolean,
    showTooltip: Boolean,
    toChild: String,
    registrationSearch: String,
    expiryDateFormate: String,
    totalRecordsData: Array,
    roleInfo: Object
  },
  data() {
    const gridColumns = [
      'Certification number',
      'Manufacturer',
      'Product category',
      'Product name',
      'Accredited by',
      'Model name',
      'Barcode',
      'Certification URL',
      'Country of origin',
      'Status',
      'Expiration',
      'Managed by',
      'Brand name',
      'Product type',
      'Product class',
      'Comments',
      'Attachments',
      'Archive reason',
      'In Progress',
      'Approval date',
      'Description',
      'Standards',
      'Ordinance',
      'Imported Product',
      'Importer',
      'Requester',
      'Trade Representative',
      'Input Status',
      'Test Report',
      'Test Report Attachments',
      'Product Certificate',
      'Product Certificate Attachments',
      'Barcode File',
      'Barcode Attachments',
      'Next maintenance date',
      'Maintenance date'
    ];
    const sortOrders = {};
    gridColumns.forEach((key) => {
      sortOrders[key] = -1;
    });
    return {
      tableHeaders: TABLE_HEADERS,
      loaderStatus: false,
      historyData: [],
      sortKey: 'Product name',
      sortOrders,
      selectedRegistration: [],
      checkAllRegistrations: false,
      activeRegistration: {},
      editFlag: '',
      tbodyHeight: '',
      dropDownMenuDisable: false,
      changeClass: false,
      selectedAttachmentRegistration: {},
      max_records_delete: 50,
      gridDataList: [],
      filterObject: { flags: {} },
      regId: ''
    };
  },
  created() {
    // We initially sync the internalValue with the value passed in by the parent
    this.selectedRegistration = this.selectedRegistrationList;
    this.$parent.$on('checkFalse', this.checkFalse);
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  },
  watch: {
    // Clear the selected record after exporting
    exportStatus() {
      if (this.exportStatus) {
        this.selectedRegistration = [];
        this.checkAllRegistrations = false;
      }
    },
    openRegistrationId: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          const row = await getRegistrationDetailsById(newVal);
          if (row && row.error) {
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text: 'Registration is not found!',
              group: 'custom-notification'
            });
          } else if (row) {
            this.viewRegistration(validateRegDetailsData(row));
          }
        }
      }
    },

    data: {
      deep: true,
      handler() {
        this.getBodyHeight();
      }
    },

    selectedRegistration() {
      if (this.selectedRegistration.length === 0) {
        this.activeId.clear();
      }
      this.$emit('selectedRegistrationListChanged', this.selectedRegistration);
    },

    filteredData: {
      deep: true,
      handler() {
        this.getBodyHeight();
      }
    },
    refreshDataAfterDeleteRecord() {
      this.checkAllRegistrations = false;
      this.selectedRegistration = [];
      this.activeId.clear();
      this.$emit('selectedRegistrationListDeleted', false);
    }
  },
  computed: {
    filteredData() {
      let { sortKey } = this;
      const filterKey = this.filterKey && this.filterKey.toLowerCase();
      const order = this.sortOrders[sortKey] || 1;
      let { data } = this;
      const gridColumns = [
        'Certification number',
        'Manufacturer',
        'Product category',
        'Product name',
        'Accredited by',
        'Model name',
        'Barcode',
        'Certification URL',
        'Country of origin',
        'Status',
        'Expiration',
        'Managed by',
        'Brand name',
        'Product type',
        'Product class',
        'Comments',
        'Attachments',
        'Archive reason',
        'modification_in_progress',
        'renewal_in_progress',
        'In Progress',
        'Description',
        'Standards',
        'Ordinance',
        'Imported Product',
        'Importer',
        'Requester',
        'Trade Representative',
        'Input Status',
        'Test Report',
        'Test Report Attachments',
        'Product Certificate',
        'Product Certificate Attachments',
        'Barcode File',
        'Barcode Attachments'
      ];
      if (filterKey && filterKey !== 'view all' && filterKey !== 'invalid records' && filterKey !== 'action needed') {
        // for view all need not filter directly display entire data

        filterKey.split(' ').forEach((search) => {
          data = data.filter((row) => {
            if (search === 'draft') {
              return row.save_draft;
            }
            return Object.keys(row).some((key) => {
              if (gridColumns.indexOf(key) === -1) {
                return false;
              }
              return (
                String(row[key])
                  .toLowerCase()
                  .indexOf(search) > -1
              );
            }) && !row.save_draft;
          });
        });
      } else {
        data = data.filter((key) => !key.save_draft);
      }
      this.$emit('filteredRegistrationsLength', data.length);
      // which filters the data based on search input field
      if (this.registrationSearch) {
        this.registrationSearch
          .toLowerCase()
          .split(' ')
          .forEach((search) => {
            data = data.filter((row) =>
              Object.keys(row).some(
                (key) =>
                  String(row[key])
                    .toLowerCase()
                    .indexOf(search) > -1
              ));
          });
      }
      if (sortKey) {
        const properData = [];
        const nonProperData = [];
        if (sortKey === 'Expiration' || sortKey === 'Approval date' || sortKey === 'Maintenance date' || sortKey === 'Next maintenance date') {
          // Date
          let sortKeyDesc = '';
          if (sortKey === 'Expiration') {
            // Expirey Date
            sortKeyDesc = 'Expiration Date';
            for (let i = 0; i < data.length; i += 1) {
              if (moment(data[i]['Expiration Date']).isValid()) {
                properData.push(data[i]);
              } else {
                nonProperData.push(data[i]);
              }
            }
          } else {
            sortKeyDesc = sortKey;
            for (let i = 0; i < data.length; i += 1) {
              if (moment(data[i][sortKey]).isValid()) {
                properData.push(data[i]);
              } else {
                nonProperData.push(data[i]);
              }
            }
          }
          if (order === 1) {
            // Ascending order
            properData.sort((a, b) => {
              const date1 = moment(a[sortKeyDesc]);
              const date2 = moment(b[sortKeyDesc]);
              return date1 - date2;
            });
          } else {
            // Descending order
            properData.sort((a, b) => {
              const date1 = moment(a[sortKeyDesc]);
              const date2 = moment(b[sortKeyDesc]);
              return date1.isBefore(date2) ? 1 : -1;
            });
          }
        } else {
          sortKey = this.returnValidKey(sortKey);
          // Non date
          for (let i = 0; i < data.length; i += 1) {
            if (data[i][sortKey] !== null && data[i][sortKey] !== '') {
              properData.push(data[i]);
            } else {
              nonProperData.push(data[i]);
            }
          }
          const list = [...properData, ...nonProperData].sort((currentRecord, nextRecord) => {
            const currentValue = currentRecord[sortKey];
            const nextValue = nextRecord[sortKey];
            if (currentValue === nextValue) return 0;
            if (currentValue > nextValue) return 1 * order;
            return -1 * order;
          });
          return list;
          // properData.sort((a1, b1) => {
          // const a = a1[sortKey];
          // const b = b1[sortKey];
          //   if (a === b) return 0 * order;
          //   if (a > b) return 1 * order;
          //   return -1 * order;
          // });
        }
        data = properData;
        data.push(...nonProperData);
      } // close of if
      return data;
    }
  },
  filters: {
    fileName(files) {
      if (files) {
        return files.map((file) => file.split('/')[file.split('/').length - 1]);
      }
      return '';
    },
    attachmentsFileName(files) {
      if (files) {
        return files.map((file) => file.attachmentLink.split('/')[file.attachmentLink.split('/').length - 1]);
      }
      return '';
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    highlight(words, registrationSearch) {
      if (words === 'Yes' || words === 'No') {
        const language = localStorage.getItem('language');
        if (language === 'Portuguese') {
          words = words === 'Yes' ? 'Sim' : 'Não';
        }
      }
      if (registrationSearch === '') {
        return words;
      }
      if (words) {
        const filterHighlight = registrationSearch.split(' ');

        const pattern = `(|\\b)(${filterHighlight.join('|')})`;
        const patternString = new RegExp(pattern, 'gi');
        const filteredText = words.replace(patternString, '<span class="highlight">$2</span>');
        return filteredText;
      }
      return words;
    }
  },
  methods: {
    translateCountry(name) {
      if (name === 'Not Available') {
        if (this.$i18n.locale === 'English') {
          return 'Not Available';
        }
        return 'Não disponível';
      }
      return name;
    },
    translateName(words) {
      const language = localStorage.getItem('language');
      if (language === 'Portuguese') {
        words = words ? 'Sim' : 'Não';
      } else {
        words = words ? 'Yes' : 'No';
      }
      return words;
    },
    translateStatus(status) {
      if (this.$i18n.locale === 'Portuguese') {
        // eslint-disable-next-line no-nested-ternary
        status = status === 'Expiring soon' ? 'Expiring_soon' : status === 'Action needed' ? 'action_needed' : status;

        const data = {
          Active: 'Ativo',
          Expired: 'Expirados',
          Expiring_soon: 'Expirando em breve',
          Pending: 'Pendente',
          Draft: 'Rascunho',
          action_needed: 'Ação necessária',
          archived: 'Arquivado'
        };
        return data[status];
      }
      return status;
    },
    translate(date) {
      if (date === 'N/A') {
        return this.$i18n.locale === 'Portuguese' ? 'N/D' : date;
      }
      const formattedDate = this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
      return formattedDate;
    },
    getFileNames(attachments, type) {
      const highlyConfidentialPermission = this.permissions.indexOf('HIGHLY_CONFIDENTIAL') > -1;
      const newAttachments = [];
      if (attachments) {
        attachments.forEach((item) => {
          if (item.highlyConfidential && !highlyConfidentialPermission) {
            console.log('item', item);
          } else {
            newAttachments.push(item);
          }
        });
      }
      if (type === 'csv') {
        return newAttachments.length
          ? newAttachments
            .map((file) => file.attachmentLink.split('/')[file.attachmentLink.split('/').length - 1])
            .join(':')
          : '';
      }
      return newAttachments.length
        ? newAttachments
          .map((file) => file.attachmentLink.split('/')[file.attachmentLink.split('/').length - 1])
          .toString()
        : '';
    },
    stopPropagateMethod(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    async viewHistory(regId, event) {
      event.stopPropagation();
      this.$emit('viewHistoryOnSelect', regId);
    },
    confirmDeleteRegistrations() {
      this.validateFilterAndGridDataMultiple();
      if (this.selectedRegistration.length >= 2) {
        // checking the selected records/registrations count with max deletion of records count
        if (this.selectedAndFilteredRecords.length > this.max_records_delete) {
          $('#registrationDelete_alert').modal({
            backdrop: 'static',
            keyboard: false
          });
        } else {
          $('#registrationDelete').modal({
            backdrop: 'static',
            keyboard: false
          });
        }
      }
    },
    confirmArchiveRegistrations() {
      this.validateFilterAndGridDataMultiple();
      if (this.selectedRegistration.length >= 2) {
        $('#registrationArchive').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    // validate selected and filtered records to archive/delete/export
    validateFilterAndGridDataMultiple() {
      const selectedRecordIds = [];
      this.selectedAndFilteredRecords = [];
      if (
        this.filterObject.flags.attachment ||
        this.filterObject.flags.expirey_date ||
        this.filterObject.flags.approval_date ||
        this.filterObject.flags.regulatory_alert ||
        this.filterObject.flags.country
      ) {
        // filter applied
        this.selectedRegistration.forEach((record) => {
          selectedRecordIds.push(record.registrationId);
        });
        this.gridDataList.forEach((record) => {
          if (selectedRecordIds.includes(record.registrationId)) {
            this.selectedAndFilteredRecords.push(record);
          }
        });
      } else {
        // selected records
        this.selectedAndFilteredRecords = [...this.selectedRegistration];
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    openAttachment(entry, event) {
      event.stopPropagation(); // To stop calling parent function
      this.selectedAttachmentRegistration = entry;
      $('#fileUploadRegi').modal({
        backdrop: 'static',
        keyboard: false
      });
      this.dropDownMenuDisable = false;
    },
    // Returns a valid key for sorting the columns
    returnValidKey(sortKey) {
      let validKey = '';
      switch (sortKey) {
        case 'Product category':
          validKey = 'registrationType';
          break;
        case 'Attachments':
          validKey = 'attachmentLinks';
          break;
        case 'Archive reason':
          validKey = 'archiveReasonName';
          break;
        case 'Model name':
          validKey = 'Device UDI';
          break;
        case 'Description':
          validKey = 'Configuration';
          break;
        case 'Product class':
          validKey = 'Device class';
          break;
        case 'Accredited by':
          validKey = 'Issued by';
          break;
        case 'Brand name':
          validKey = 'Local distributor';
          break;
        case 'Managed by':
          validKey = 'Local representative';
          break;
        case 'Certification number':
          validKey = 'Submission number';
          break;
        case 'Certification URL':
          validKey = 'Record number';
          break;
        case 'Product type':
          validKey = 'Device type';
          break;
        case 'Country of origin':
          validKey = 'Country';
          break;
        case 'Product name':
          validKey = 'Product';
          break;
        case 'Standards':
          validKey = 'standards';
          break;
        case 'Ordinance':
          validKey = 'ordinance';
          break;
        case 'Imported Product':
          validKey = 'imported_product';
          break;
        case 'Importer':
          validKey = 'importer';
          break;
        case 'Requester':
          validKey = 'requester';
          break;
        case 'Trade Representative':
          validKey = 'trade_representative';
          break;
        case 'Input Status':
          validKey = 'inputStatus';
          break;
        case 'Test Report':
          validKey = 'test_report';
          break;
        case 'Test Report Attachments':
          validKey = 'test_report_attachments';
          break;
        case 'Product Certificate':
          validKey = 'product_certificate';
          break;
        case 'Product Certificate Attachments':
          validKey = 'product_certificate_attachments';
          break;
        case 'Barcode File':
          validKey = 'barcodeFile';
          break;
        case 'Barcode Attachments':
          validKey = 'barcode_attachments';
          break;
        default:
          validKey = sortKey;
          break;
      }
      return validKey;
    },
    // To Disable modal on select of tracker dots
    menuDropdown(event) {
      this.dropDownMenuDisable = true;
      this.changeClass = false;
      if (event.screenY > window.innerHeight - 90) {
        this.changeClass = true;
      } else {
        this.changeClass = false;
      }
    },
    // share emailLink
    shareEmailLinkOnSelect(registrationObj, event) {
      event.stopPropagation(); // To stop calling parent function
      const data = {
        mode: '1',
        id: registrationObj.registrationId,
        sendTo: '1',
        isLink: true
      };
      this.$emit('shareEmailLinkOnSelect', data, registrationObj);
    },
    // export selected Registration
    exportRegistrationOnSelect(registrationObj, all = false, event) {
      event.stopPropagation(); // To stop calling parent function
      const exportObject = {
        registrationObj,
        all
      };
      this.$emit('exportRegistrationOnSelect', exportObject);
    },
    // Delete selected Registration
    deleteRegistrationOnSelect(registrationObj, event) {
      event.stopPropagation(); // To stop calling parent function
      this.$emit('deleteRegistrationOnSelect', registrationObj);
    },
    // Archive selected Registration
    archiveRegistrationOnSelect(registrationObj, event) {
      event.stopPropagation(); // To stop calling parent function
      this.$emit('archiveRegistrationOnSelect', registrationObj);
    },
    // Edit record
    async editRecord(id, type, invalidRecord, entry) {
      sessionStorage.setItem('selectedRecord', JSON.stringify(entry));
      if (type === 'false' || type === false) this.$router.push({ path: `/layout/registration/add-record/${id}`, query: { type, invalidRecord } });
      else if (entry.save_draft) {
        this.$router.push({ path: `/layout/registration/flow/add-record/${id}`, query: { type } });
      } else {
        const regCheck = await isRegulationChecked(id);
        if (regCheck.isRegistrationCheckComplete) {
          const todoCheck = await getToDoListDetails(id);
          localStorage.setItem('registrationType', entry.registrationTypeId);
          if (!todoCheck.status) {
            this.$router.push({ path: `/layout/registration/flow/provide-evidence/${id}` });
          }
        } else {
          this.$router.push({ path: `/layout/registration/flow/regulation-check/${entry.registrationTypeId}/${id}` });
        }
      }
    },
    reviewCertificate(id, type, isReview) {
      this.$router.push({ path: `/layout/registration/add-record/${id}`, query: { type, isReview } });
    },
    renewCertificate(id) {
      this.regId = id;
      $('#deleteRecord').modal('show');
    },
    async proceedChanges() {
      const type = false;
      await updateStatus(JSON.parse(localStorage.getItem('userData')).account_id, this.regId);
      this.$router.push({ path: `/layout/registration/add-record/${this.regId}`, query: { type } });
    },
    disableModal(registrationId, event) {
      event.stopPropagation();
      if ($(`#${registrationId}`).hasClass('td-selected-row')) {
        // remove td-selected-row on un-select
        this.activeId.delete(registrationId);
      } else if (!this.activeId.has(registrationId)) {
        // enable td-selected-row css
        this.activeId.add(registrationId);
      }
    },
    setSearch(value) {
      // this.activeId = new Set();
      this.$emit('setSearch', value);
    },

    hidePopup(value) {
      this.editFlag = value;
    },

    countryFlag(registrationObj) {
      return `flag-icon-${registrationObj['Country Code'].toLowerCase()}`;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] *= -1;
    },

    viewRegistration(record, event) {
      if (event) {
        if (!$(event.target).closest('#export-dots').length) {
          this.activeRegistration = record;
          if (!this.dropDownMenuDisable && this.filterKey.toLowerCase() !== 'invalid records') {
            this.$router.push({ path: `/layout/view-record/${record.registrationId}?type=compliance` });
          } else {
            this.dropDownMenuDisable = false;
          }
        }
      }
    },
    closeModal(e) {
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.dropDownMenuDisable = false;
    },
    getBodyHeight() {
      // this.tbodyHeight = this.$refs.tbodyBox.offsetHeight;
    },
    titleMessage(status, user) {
      if (status.toLowerCase() === 'expired') {
        const expStmt = this.$i18n.locale === 'English' ? 'Registration is Expired.' : 'O registro está expirado.';
        const renModStmt = this.checkRenewalModification(user);
        if (renModStmt) {
          return `${expStmt}<br/>${renModStmt}`;
        }
        return expStmt;
      }
      if (status.toLowerCase() === 'pending') {
        return this.$i18n.locale === 'English' ? 'Registration is pending.' : 'O registro está pendente.';
      }
      if (status.toLowerCase() === 'expiring soon') {
        let days = '';
        if (this.$i18n.locale === 'English') {
          days = user.resolve === 1 ? 'day' : 'days';
        } else {
          days = user.resolve === 1 ? 'dia' : 'dias';
        }
        const stmt =
          this.$i18n.locale === 'English'
            ? `Registration will expire in ${user.resolve} ${days}`
            : `O registro expirará em ${user.resolve} ${days}`;
        const renModStmt = this.checkRenewalModification(user);
        if (renModStmt) {
          return `${stmt}<br/>${renModStmt}`;
        }
        return stmt;
      }
      if (status.toLowerCase() === 'archived') {
        return this.$i18n.locale === 'English' ? 'Registration is archived.' : 'O registro é arquivado.';
      }
      if (this.status === 'Active' && !this.user.renewal_in_progress && !this.user.modification_in_progress) {
        this.showPop = false;
      } else {
        this.showPopup = true;
      }
      return '';
    },
    checkRenewalModification(user) {
      if (user.renewal_in_progress && user.modification_in_progress) {
        return this.$i18n.locale === 'English'
          ? 'Renewal and modification is in progress'
          : 'A renovação e a modificação estão em andamento';
      }
      if (user.renewal_in_progress || user.modification_in_progress) {
        if (user.renewal_in_progress) {
          return this.$i18n.locale === 'English' ? 'Renewal is in progress' : 'A renovação está em andamento';
        }
        if (user.modification_in_progress) {
          return this.$i18n.locale === 'English' ? 'Modification is in progress' : 'A modificação está em andamento';
        }
      }
      return '';
    },
    checkFalse() {
      this.checkAllRegistrations = false;
      this.selectedRegistration = [];
    },
    selectAll() {
      if (!this.checkAllRegistrations) {
        this.selectedRegistration = [];
        this.filteredData.forEach((item) => {
          this.selectedRegistration.push(item);
          this.activeId.add(item.registrationId); // enable td-selected-row css
        });
      } else {
        this.selectedRegistration = [];
        this.activeId.clear(); // remove td-selected-row css
        this.checkAllRegistrations = false;
      }
    },
    deselectAll() {
      this.selectedRegistration = [];
      this.activeId.clear(); // remove td-selected-row css
      this.checkAllRegistrations = false;
    },
    deselect(event) {
      if (!event.target.checked) {
        this.checkAllRegistrations = false;
      } else if (event.target.checked && this.selectedRegistration.length + 1 === this.filteredData.length) {
        this.checkAllRegistrations = true;
      }
    },
    splitCommaString(text) {
      if (!text) {
        return [];
      }
      return text.split(', ');
    }
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
    this.$root.$on('cancelSelected', (flag) => {
      if (flag) {
        this.selectedRegistration = [];
        this.activeId.clear();
        this.checkAllRegistrations = false;
      }
    });
    EventBus.$on('updateSelectedRegistration', (data) => {
      this.activeRegistration = data;
    });
    this.$nextTick(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });
    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
  }
};
</script>
<style scoped>
.cursor-text {
  cursor: text;
}
.image-size {
  width: 18px;
  height: 18px;
}
.pl-10 {
  padding-left: 10px;
}
.mt-2 {
  margin-top: 2px;
}
.dropdown-menu-ul {
  position: absolute;
  left: -186px;
}
/* .no-records-found {
  background: #ffffff;
} */

.tableHeader {
  display: flex;
  align-items: center;
  column-gap: 7px;
}

.header-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-menu li {
  padding: 0px;
}

.dropdown-menu li:not(:last-child) {
  margin-bottom: 16px;
  color: #01518a;
}

.dropdown-menu {
  width: 220px;
  border: none;
  border-radius: 5px;
  filter: drop-shadow(0px 0px 10px #b2b2b2);
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  top: 34px;
  background: #ffffff;
  padding: 20px;
  border: 1px solid #d3d3d3;
  border-radius: 0px 0px 4px 4px;
}
.tooltip-pointer:before {
  position: absolute;
  top: -12px;
  height: 0;
  width: 0;
  /* left: 83%; */
  right: 10px;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 12px solid #ffffff;
  content: '';
}
.dropdown-menu > li > a {
  padding: unset;
}

.dropdown-export {
  float: unset;
  text-align: center;
  display: flex !important;
  justify-content: center;
}

.w-100 {
  width: 100%;
}

.emergo-table thead th:first-child {
  padding: 13px 14px 17px 12px !important;
}

.emergo-table.table tbody td:first-child {
   padding: 14px 14px 16px 12px !important;
}

.addReverse {
  top: auto !important;
  bottom: 100%;
  margin-bottom: initial;
}
.addReverse.tooltip-pointer:before {
  transform: rotate(180deg);
  top: 100%;
}
.el-link.is-underline:hover:after {
  border-bottom: none;
  color: #606266;
}
</style>
